<!-- =========================================================================================
    File Name: Device.vue
    Description: Dashcam page
========================================================================================== -->

<template>
  <div>
    <device-sidebar :isSidebarActive="dataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData"  />
    <device-excel-import :isPopupActive="deviceUploadPopup" @close="toggleDeviceUploadPopup" />
    <device-add-popup :isPopupActive="deviceAddPopup" @close="toggleDeviceAddPopup" />
    <vx-card class="overflow-auto">
      <div class="flex flex-wrap-reverse items-center flex-grow">
        <vs-button icon-pack="feather" icon="icon-download" class="m-2" @click="exportExcel()">{{$t('EXPORT_EXCEL')}}</vs-button>
        <vs-button v-if="onlyAdmin" type="border" icon-pack="feather" icon="icon-plus" class="m-2" @click="addDevice()">{{$t('ADD_DEVICE')}}</vs-button>
        <vs-button v-if="onlyAdmin" type="border" icon-pack="feather" icon="icon-upload" class="m-2" @click="uploadExcel()">{{$t('DEVICE_EXCEL_UPLOAD')}}</vs-button>
      </div>
      <v-server-table id="device-table" ref="deviceTable" name="deviceTable" 
        :columns="columns" :options="options" @loading="onLoading" @loaded="onLoaded" @sorted="setSortedForExcel" @filter="setFilterForExcelIncludeDateFilter">
          <vs-chip slot="deviceStatus" slot-scope="props" :color="getDeviceStatusColor(props.row.device.deviceStatus)" class="w-full">
            {{$t(setDeviceStatusName(props.row.device.deviceStatus))}}
          </vs-chip>
          <vs-chip slot="serviceStatus" slot-scope="props" :color="getServiceStatusColor(props.row.device.serviceStatus)" class="w-full">
            {{$t(setServiceStatusName(props.row.device.serviceStatus))}}
          </vs-chip>
          <vs-chip slot="usedSubscribe" slot-scope="props" :color="getUsedSubscribeColor(props.row.device.usedSubscribe)" class="w-full">
            {{$t(setUsedSubscribeName(props.row.device.usedSubscribe))}}
          </vs-chip>
          <div slot="edit" slot-scope="props">
             <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"  @click.stop="editData(props.row)"/>
          </div>
      </v-server-table>
    </vx-card>
  </div>
</template>

<script>
let FileSaver = require('file-saver');

import DeviceSidebar from './DeviceSidebar.vue'
import moduleDevice from "@/store/device/moduleDevice.js"
import DeviceExcelImport from "./DeviceExcelImport.vue"
import DeviceAddPopup from "./DeviceAddPopup.vue"
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
  components: {
    DeviceSidebar,
    DeviceExcelImport,
    DeviceAddPopup,
    DatePicker
  },
  data() {
    return {
      // Data Sidebar
      dataSidebar: false,
      sidebarData: {},
      
      deviceUploadPopup: false,
      deviceAddPopup: false,

      // Table
      columns: ['deviceUUID', 'userId',  'deviceStatus',  'serviceStatus', 'usedSubscribe', 'lastConnectedTime', 'promotionStartDateTime', 'edit'],
      options: {
        perPage: 10,
        skin: 'table',
        filterByColumn: true,
        filterable: ['userId', 'deviceUUID', 'deviceStatus',  'serviceStatus', 'usedSubscribe', 'lastConnectedTime', 'promotionStartDateTime'],
        sortable: ['userId', 'deviceStatus',  'serviceStatus', 'usedSubscribe', 'lastConnectedTime', 'promotionStartDateTime'],
        orderBy: { ascending: true },
        debounce: 1000,
        dateColumns:['lastConnectedTime', 'promotionStartDateTime'],
        dateFormat: 'YYYY-MM-DD',
        toMomentFormat: 'YYYYMMDD',
        datepickerOptions: {
            showDropdowns: true,
            autoUpdateInput: true,
        },
        sortIcon: {
          base: 'feather',
          up: 'icon-arrow-up',
          down: 'icon-arrow-down',
        },
        texts: {
          filterBy: this.$t("FILTER_BY"),
          defaultOption: this.$t("DEFAULT_OPTION"),
        },
        headings: {
           'userId': () => this.$t("USER_ID"),
           'deviceUUID': () => this.$t("DEVICE_UUID"),
           'deviceStatus': () => this.$t("DEVICE_STATUS"),
           'serviceStatus': () => this.$t("SERVICE_STATUS"),
           'usedSubscribe': () => this.$t("USED_SUBSCRIBE_STATUS"),
           'lastConnectedTime': () => this.$t("LAST_CONNECTED_TIME"),
           'promotionStartDateTime': () => this.$t("PROMOTION_START_DATETIME"),
           'edit': () => this.$t("EDIT")
        },
        listColumns: {
          deviceStatus: [
            {
              id: '0',
              text: this.$t("DEACTIVATED")
            },
            {
              id: '1',
              text: this.$t("ACTIVATED")
            },
            {
              id: '2',
              text: this.$t("BLOCKED")
            },
            {
              id: '3',
              text: this.$t("BROKEN")
            }
          ],
          serviceStatus: [
            {
              id: '0',
              text: this.$t("OUT_OF_SERVICE")
            },
            {
              id: '1',
              text: this.$t("IN_SERVICE")
            },
          ],
          usedSubscribe: [
            {
              id: '0',
              text: this.$t("NOT_USED_SUBSCRIBE")
            },
            {
              id: '1',
              text: this.$t("USED_SUBSCRIBE")
            },
            {
              id: '2',
              text: this.$t("USING_SUBSCRIBE")
            },
          ]
        },
        requestAdapter: function(data) {

           if(data.query.lastConnectedTime){
            data.query = {...data.lastConnectedTimeAdditional, ...data.query};

            let localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
            let start = moment.tz(data.query.lastConnectedTime.start, localTimeZone).utc().format('YYYY-MM-DD HH:mm:ss')
            let end = moment.tz(data.query.lastConnectedTime.end, localTimeZone).utc().format('YYYY-MM-DD HH:mm:ss')
            
            data.query.lastConnectedTimeUTC.start = start
            data.query.lastConnectedTimeUTC.end = end
          }

           if(data.query.promotionStartDateTime){
            data.query = {...data.promotionStartDateTimeAdditional, ...data.query};

            let localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
            let start = moment.tz(data.query.promotionStartDateTime.start, localTimeZone).utc().format('YYYY-MM-DD HH:mm:ss')
            let end = moment.tz(data.query.promotionStartDateTime.end, localTimeZone).utc().format('YYYY-MM-DD HH:mm:ss')
            
            data.query.promotionStartDateTimeUTC.start = start
            data.query.promotionStartDateTimeUTC.end = end
          }

          return {
            ascending: data.ascending,
            byColumn: data.byColumn,
            pageSize: data.limit,
            orderBy: data.orderBy ? data.orderBy : "userId",
            page: data.page,
            query: data.query,
            pageResult: ((data.page-1)*data.limit)
          };
        },
        params: {
          lastConnectedTimeAdditional:{
            lastConnectedTimeUTC: {
              start: '',
              end: ''
            },
          },
          promotionStartDateTimeAdditional:{
            promotionStartDateTimeUTC: {
              start: '',
              end: ''
            }
          } 
        }, 
        requestFunction: function (data) {
          return this.$http.get('/api/device-management/devices', {
                params: data
          }).catch(function (e) {
                this.dispatch('error', e);
                this.$vs.loading.close()
          }.bind(this));
        },
        responseAdapter: (response) => {
          this.$store.commit('dataDevice/SET_DEVICE',response.data)
          return {
            data: this.$store.state.dataDevice.deviceList,
            count: this.$store.state.dataDevice.count
          }
        },
        templates:{
          userId: function(h,row){
            if(!row.user){
              return '-'
            }else{
              return row.user.userId
            }
          },
          deviceUUID: function(h,row){
            return row.device.deviceUUID;
          },
          deviceStatus: function(h,row){
            return row.device.deviceStatus
          },
          serviceStatus: function(h,row){
            return row.device.serviceStatus
          },
          usedSubscribe: function(h,row){
            return row.device.usedSubscribe
          },
          lastConnectedTime: function(h,row){
            let lastConnectedTime = row.device.lastConnectedTime
            if(!lastConnectedTime){
              return '-'
            }else {
              let localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
              let dateTime = this.$moment(lastConnectedTime,'YYYYMMDDHHmmss').format()
              let dateTimeToLocal = this.$moment.tz(dateTime, localTimeZone).format('YYYY-MM-DD HH:mm:ss')
          
              return dateTimeToLocal
            }
          },
          promotionStartDateTime: function(h,row){
            let promotionStartDateTime = row.device.promotionStartDateTime
            if(!promotionStartDateTime){
              return '-'
            }else {
              let localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
              let dateTime = this.$moment(promotionStartDateTime,'YYYYMMDDHHmmss').format()
              let dateTimeToLocal = this.$moment.tz(dateTime, localTimeZone).format('YYYY-MM-DD HH:mm:ss')
          
              return dateTimeToLocal
            }
          }
        }
      }
    }
  },
  computed:{
    onlyAdmin() {
      return this.$store.state.AppActiveUser.userRole === 'admin' ? this.$acl.check(this.$store.state.AppActiveUser.userRole) : false
    },
  },
  created() {
    if(!moduleDevice.isRegistered) {
      this.$store.registerModule('dataDevice', moduleDevice)
      moduleDevice.isRegistered = true
    }
    this.$store.dispatch("dataDevice/fetchDeviceStatus")
    this.$store.dispatch("dataDevice/fetchUsedSubscribe")
    
  },
  methods: {
    // Sidebar
    toggleDataSidebar(val=false) {
      this.dataSidebar = val
    },
    editData(data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    toggleDeviceUploadPopup(val=false) {
      this.deviceUploadPopup = val
    },
    uploadExcel(){
      this.toggleDeviceUploadPopup(true)
    },
    toggleDeviceAddPopup(val=false) {
      this.deviceAddPopup = val
    },
    addDevice(){
      this.toggleDeviceAddPopup(true)
    },
    getDeviceStatusColor(status) {
      if(status === "") return "primary"
      return this.$store.state.commonConfig.deviceStatus.properties[status].color
    },
    setDeviceStatusName(status){
      if(status === "") return ""
      return this.$store.state.commonConfig.deviceStatus.properties[status].name
    },
    getServiceStatusColor(status) {
      if(status === "") return "primary"
      return this.$store.state.commonConfig.serviceStatus.properties[status].color
    },
    setServiceStatusName(status){
      if(status === "") return ""
      return this.$store.state.commonConfig.serviceStatus.properties[status].name
    },
    getUsedSubscribeColor(status) {
      if(status === "") return "primary"
      return this.$store.state.commonConfig.usedSubscriptionStatus.properties[status].color
    },
    setUsedSubscribeName(status){
      if(status === "") return ""
      return this.$store.state.commonConfig.usedSubscriptionStatus.properties[status].name
    },
    setLastConnectedTime(dateTime){
      if(!dateTime){
        return '-'
      }else{
        let dateTimeArray = dateTime.split('.')
        return dateTimeArray[0]
      }
    },
    exportExcel(){

      let locale = this.$i18n.locale

      this.$http({
        method: 'post',
        url: '/api/device-management/devices/excel/'+locale,
        data:{
          query : JSON.stringify(this.filterForExcel),
          orderBy: this.sortForExcel.column ? this.sortForExcel.column : 'userId' ,
          ascending: this.sortForExcel.ascending ? 1 : 0,
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
        },
        withCredentials: true,
        responseType: 'blob',
        headers: {
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }).then((response) => {
        let excelTitle
        if(locale === "ko"){
          excelTitle = "대시캠_목록.xlsx"
        }else{
          excelTitle ="Dashcam_List.xlsx"
        }
        FileSaver.saveAs(response.data, excelTitle)
      }).catch((error)=> {
        console.log(error);
      }) 
    },
  },
}

</script>

<style lang="scss" scoped>
#device-table {
  text-align: center;
}
</style>